import useCreditTransactions from './hooks/useCreditTransactions';
import {
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHead,
    TableCell,
    TablePagination
} from '../../../../components/ui/table';
import { Alert, AlertDescription } from '../../../../components/ui/alert';
import { LoadingSpinner } from '../../../../components/ui/loading';
import { formatDate } from '../../../../utility/date';

const CreditsTransactionsTable = () => {
    const {
        data,
        loading,
        error,
        currentPage,
        totalPages,
        goToPage,
        handleSort,
        sortOrder,
        limit,
        setLimit,
        sortField,
        calculateCreditsAdded
    } = useCreditTransactions({ initialLimit: 5 });

    if (error) return <Alert variant='danger'><AlertDescription><strong>Error:</strong> {error}</AlertDescription></Alert>;

    if (loading) <LoadingSpinner centered />

    if (!data || data.length === 0) return <Alert variant='info'><AlertDescription>No credit transactions found.</AlertDescription></Alert>;

    // const t = data.reduce((acc, item) => acc + Number(calculateCreditsAdded(item)), 0);
    // console.log("Total Credits Added: ", t);
    // console.log("Data.LENGTH: ", data.length);
    return (
        <div className="card-body py-3">
            <Table>
                <TableHeader>
                    <TableHead
                        className="ps-4"
                        width="150px"
                        onSort={() => handleSort('creditedAt')}
                        sortDirection={sortField === 'creditedAt' ? sortOrder : null}
                    >
                        Added On
                    </TableHead>
                    <TableHead width="100px">Amount</TableHead>
                    <TableHead width="100px">Tax</TableHead>
                    <TableHead width="100px">Credits Added</TableHead>
                    <TableHead width="100px">Type</TableHead>
                    <TableHead width="150px">Invoice</TableHead>
                </TableHeader>

                <TableBody>
                    {data.map((item) => (
                        <TableRow key={item._id}>
                            <TableCell className="ps-4">
                                <span className="text-dark fw-bolder text-hover-primary d-block fs-6">
                                    {formatDate(item.creditedAt, 'dd/MM/yy hh:mm a')}
                                </span>
                            </TableCell>
                            <TableCell>
                                <span className="text-gray-800 fw-bolder d-block fs-6">
                                    {item.currency === "INR" ? "₹" : "$"}{item.amount.toFixed(2)}
                                </span>
                            </TableCell>
                            <TableCell>
                                <span className="text-gray-600 fw-bold d-block fs-6">
                                    {item.currency === 'INR' ? `₹${item.tax.toFixed(2)}` : `$${item.tax.toFixed(2)}`}
                                </span>
                            </TableCell>
                            <TableCell>
                                <span className="text-gray-600 fw-bold d-block fs-6">
                                    ${calculateCreditsAdded(item)}
                                </span>
                            </TableCell>
                            <TableCell>
                                <span className={`badge ${item.category === 'Paid' ? 'badge-light-primary' : 'badge-light-success'} fs-7 fw-bold`}>
                                    {item.category}
                                </span>
                            </TableCell>
                            <TableCell>
                                {item.invoiceLink ? (
                                    <a
                                        href={item.invoiceLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary fw-bolder fs-6 text-hover-primary"
                                    >
                                        View Invoice
                                    </a>
                                ) : (
                                    <span className="text-gray-500 fw-bold d-block fs-6">-</span>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <TablePagination
                currentPage={currentPage}
                totalPages={totalPages}
                limit={limit}
                onPageChange={goToPage}
                onLimitChange={setLimit}
            />
        </div>
    );
};

export default CreditsTransactionsTable;